import React from "react"
import {Button} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {RootState} from "../../../Redux";

interface RegistrationServiceButtonProps {
    handleSelect: (action: string) => void
}

const RegistrationServiceButton = ({handleSelect}: RegistrationServiceButtonProps) => {
    const { t } = useTranslation()

    const registrationServiceAvailable = useSelector(
        (state: RootState) => state.ui.settings.selfService.registrationServiceAvailable) || false;

    if (!registrationServiceAvailable) {
        return <></>
    }

    return (
        <Button
            variant={"contained"}
            onClick={() => handleSelect("registrationService")}
        >
            <div>
                {t('selfService.registrationServices')}
                <div style={{textAlign: "left", textTransform: "none", lineHeight: 1.5, fontSize: "60%"}}>
                    <ul>
                        <li>{t('selfService.initialRegistration')}</li>
                        <li>{t('selfService.vehicleInsurance')}</li>
                        <li>{t('selfService.changeOfOwner')}</li>
                        <li>{t('selfService.trafficUseRegistration')}</li>
                        <li>{t('selfService.usageInformationChange')}</li>
                        <li>{t('selfService.transferPermits')}</li>
                        <li>{t('selfService.licensePlateOrders')}</li>
                    </ul>
                </div>
            </div>
        </Button>
    )
}

export default RegistrationServiceButton